import logger from "./utils/logger.js";

// Environment check
const isProduction = process.env.NODE_ENV === 'production';

// API Keys and configuration - these will be overridden by .env in production
const HELIUS_API_KEY = process.env.REACT_APP_HELIUS_API_KEY || '';
const STABLEBOND_PROGRAM_ID = process.env.REACT_APP_STABLEBOND_PROGRAM_ID || 'YOUR_DEV_PROGRAM_ID';

// API URLs - Use environment variables for all sensitive configurations
const RPC_URL = process.env.REACT_APP_HELIUS_RPC_URL || 'https://mainnet.helius-rpc.com/?api-key=fa1fa628-f674-4fa6-8b63-6f9b85c18166';
const SOL_RPC_URL = process.env.REACT_APP_SOL_RPC_URL || 'https://solana-mainnet.g.alchemy.com/v2/C5-LCLXSwlCEtsquSDPIj';

export const CONFIG = {
  // Environment
  ENV: isProduction ? 'production' : 'development',
  
  // RPC Configuration
  RPC_URL,
  // Backward-compatible alias used by older code
  HELIUS_RPC_URL: RPC_URL,
  SOL_RPC_URL,
  
  // Program IDs
  STABLEBOND_PROGRAM_ID,
  
    // API Endpoints - Use environment variable if set, otherwise default to current origin
  API_BASE_URL: process.env.REACT_APP_API_URL || (isProduction 
    ? window.location.origin
    : 'http://localhost:3002'),
    
  // PAJ API Configuration
  PAJ_API_URL: isProduction
    ? 'https://api.paj.cash'
    : 'https://api-staging.paj.cash',
  PAJ_BUSINESS_API_KEY: process.env.REACT_APP_PAJ_BUSINESS_API_KEY || '',
    
  // Feature Flags
  FEATURES: {
    USE_PRODUCTION_DATA: isProduction,
    ENABLE_ANALYTICS: isProduction
  }
};

// Log configuration details (safely)
logger.log(`Running in ${CONFIG.ENV} mode`);
logger.log('Using RPC URL:', RPC_URL ? RPC_URL.replace(/api-key=[^&]*/, 'api-key=***') : 'Not set');
